import { z } from 'zod';

/**
 * Doc 05 says lists are `{ items, nextCursor }`, but the setup-entity queries
 * (JobsQuery, UsersQuery, EquipmentQuery) carry no cursor. Accept both shapes
 * so the web app works whichever the API settles on.
 */
export function listOf<T extends z.ZodTypeAny>(item: T) {
  return z
    .union([
      z.array(item),
      z.object({ items: z.array(item), nextCursor: z.string().nullable().optional() }),
    ])
    .transform((v): { items: z.infer<T>[]; nextCursor: string | null } =>
      Array.isArray(v)
        ? { items: v, nextCursor: null }
        : { items: v.items, nextCursor: v.nextCursor ?? null },
    );
}
